import type { SiteNewsItem } from "../../types/api";

export const fallbackNews: SiteNewsItem[] = [
  {
    title:
      "Nollywood Legend Segun Arinze Arrives In Ghana Ahead Of The Black Star (The Teacher Of Africa) Stage Play",
    slug: "segun-arinze-arrives-in-ghana-ahead-of-the-black-star",
    excerpt:
      "The Kotoka International Airport came alive yesterday as Nollywood veteran Segun Arinze arrived in Ghana ahead of The Black Star stage play.",
    body:
      "The Kotoka International Airport came alive yesterday as Nollywood veteran Segun Arinze arrived in Ghana ahead of The Black Star stage play.",
    image: "/assets/news-segun-arrives.jpg",
    imageAlt: "Segun Arinze arriving in Ghana ahead of The Black Star stage play",
    author: "African Art Network",
    publishedAt: "2026-08-15",
    published: true,
  },
  {
    title:
      "Segun Arinze Joins Andrew Tandoh-Adote to Star in The Black Star (The Teacher of Africa) Theatre Production",
    slug: "segun-arinze-joins-andrew-tandoh-adote-for-the-black-star",
    excerpt:
      "The spirit of Pan-Africanism is set to come alive on stage as two of Africa's finest actors prepare for The Black Star theatre production.",
    body:
      "The spirit of Pan-Africanism is set to come alive on stage as two of Africa's finest actors prepare for The Black Star theatre production.",
    image: "/assets/news-segun-andrew.jpeg",
    imageAlt: "Segun Arinze and Andrew Tandoh-Adote for The Black Star theatre production",
    author: "African Art Network",
    publishedAt: "2026-08-15",
    published: true,
  },
  {
    title:
      "African Art Network's HONEYMOON HOTEL Delivers a Bold, Brilliant, Powerful Shift for Ghana's Theatre Industry",
    slug: "honeymoon-hotel-delivers-powerful-shift-for-ghanas-theatre-industry",
    excerpt:
      "By Mustapha Yahaya Last weekend at the National Theatre, Accra, the curtains rose on one of the most memorable theatre moments.",
    body:
      "By Mustapha Yahaya Last weekend at the National Theatre, Accra, the curtains rose on one of the most memorable theatre moments.",
    image: "/assets/news-honeymoon.jpg",
    imageAlt: "Honeymoon Hotel theatre production cast on stage",
    author: "Mustapha Yahaya",
    publishedAt: "2026-08-15",
    published: true,
  },
  {
    title:
      "Shirley Frimpong-Manso Makes Her Theatre Debut with 'Honeymoon Hotel' - Courtesy African Art Network",
    slug: "shirley-frimpong-manso-makes-theatre-debut-with-honeymoon-hotel",
    excerpt:
      "Award-winning filmmaker Shirley Frimpong-Manso makes her theatre debut with Honeymoon Hotel, courtesy of African Art Network.",
    body:
      "Award-winning filmmaker Shirley Frimpong-Manso makes her theatre debut with Honeymoon Hotel, courtesy of African Art Network.",
    image: "/assets/news-shirley.jpg",
    imageAlt: "Shirley Frimpong-Manso at the Honeymoon Hotel theatre debut",
    author: "African Art Network",
    publishedAt: "2026-08-15",
    published: true,
  },
];

export function newsDetailPath(slug: string) {
  return `/news/${slug}`;
}
